import { capitalDesignTokens, createTypedSxStyles } from '@opengov/capital-mui-theme';

const { semanticColors } = capitalDesignTokens;

export const styles = createTypedSxStyles({
  headerImageContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& img': {
      height: '100%',
      width: '100%',
      objectFit: 'cover',
    },
  },
  noImagePlaceholder: {
    backgroundColor: '#eeeeee',
    '& svg': {
      fill: semanticColors.foreground.secondary,
      width: '35px',
      height: '35px',
    },
  },
  tocPreviewBody: {
    padding: '24px',
    backgroundColor: semanticColors.background.primary,
  },
  placeholderTextContainer: {
    marginTop: '24px',
    display: 'flex',
  },
  column: {
    flex: 1,
  },
  descriptionText: {
    marginTop: '8px',
  },
});
